export const hasTrackingPrevention = typeof window !== 'undefined' &&
    window.document &&
    'requestStorageAccess' in document &&
    typeof document.requestStorageAccess === 'function';
const ID_RAMBLER_RU = 'id.rambler.ru';
const ID_LENTA_RU = 'id.lenta.ru';
const DEFAULT_SSO = [
    'secretmag',
    'eda',
    'lenta',
    'afisha',
    'champ',
    'motor',
    'quto',
    'passion',
    'ferra',
    'lentaru',
    'wmj',
    'letidor',
    'indicator',
    'moslenta'
];
const ITP_DOMAIN_BY_RNAME = {
    default: ID_RAMBLER_RU,
    secretmag: 'id.secretmag.ru',
    eda: 'rid.eda.ru',
    lenta: ID_LENTA_RU,
    afisha: 'idrambler.afisha.ru',
    champ: 'id.championat.com',
    motor: 'id.motor.ru',
    quto: 'id.quto.ru',
    passion: 'id.passion.ru',
    ferra: 'id.ferra.ru',
    lentaru: ID_LENTA_RU,
    wmj: 'id.wmj.ru',
    letidor: 'id.letidor.ru',
    indicator: 'id.indicator.ru',
    moslenta: 'id.moslenta.ru',
    smailbox: 'id.smailbox.ru'
};
export const getItpUrls = (rnames = DEFAULT_SSO) => [
    ...new Set([
        ITP_DOMAIN_BY_RNAME.default,
        ...rnames.map((rname) => ITP_DOMAIN_BY_RNAME[rname]).filter(Boolean)
    ])
];
const CDN_ORIGIN = 'https://id.rambler.ru';
const trimSld = (domain) => domain.split('.').slice(-2).join('.');
export const getFirstPartyOrigin = () => {
    if (typeof window === 'undefined')
        return '';
    const { hostname } = window.location;
    const [domain] = hasTrackingPrevention
        ? getItpUrls(Object.keys(ITP_DOMAIN_BY_RNAME)).filter((d) => trimSld(d) === trimSld(hostname))
        : [];
    return domain ? `https://${domain}` : CDN_ORIGIN;
};
